import React from 'react';
import { Grid } from '@material-ui/core';
import { VaccinationRules } from '../../components';

const VetVaccinationRulesPage: React.FC<any> = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <VaccinationRules />
      </Grid>
    </Grid>
  );
};

export default VetVaccinationRulesPage;
